import { Form, Input, Spin } from "antd";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import Header from "../Header";
import { obfuscateEmail } from "../../../utils";
import { save, saveOtp } from "../../../features/auth/authSlice";
import toast from "react-hot-toast";
import RightSide from "../RightSide";

function VerifyEmail() {
  const [form] = Form.useForm();
  const formRef = useRef(null);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [formData, setFormData] = useState({});
  const [isInputEmpty, setIsInputEmpty] = useState(true);

  const [counter, setCounter] = useState({ minutes: 0, seconds: 59 });
  const [activeResend, setActiveResend] = useState(false);
  const { subdomain } = useSelector((state) => state.global);

  const { accType, forgotAcc, saving } = useSelector((state) => state.auth);
  const resendOTPEmail = async () => {
    const res = await dispatch(
      saveOtp({
        usrId: forgotAcc?.usrId,
        url: `auth/resend-otp`,
      })
    );
    if (res?.payload?.success) {
      toast.success(res.payload?.messages?.message);
    } else {
      toast.error(res.payload?.messages?.message);
    }
  };

  const handleBack = async () => {
    await navigate("/forgot-password");
  };

  const onFinish = async (data) => {
    const res = await dispatch(
      save({
        usrId: forgotAcc?.usrId,
        usrSecret: data?.usrSecret,
        url: "auth/validate-forgot-pwd-otp",
      })
    );
    if (res?.payload?.success) {
      toast.success(res.payload?.messages?.message);
      await navigate("/new-password");
      setIsInputEmpty(true);
      form.resetFields();
    } else {
      toast.error(res.payload?.messages?.message);
    }
  };

  const handleInputChange = (e) => {
    const value = e.target.value;
    setIsInputEmpty(!value);
    setFormData((prevData) => ({
      ...prevData,
      usrFirstName: value,
    }));
  };

  useEffect(() => {
    const interval = setInterval(() => {
      if (counter.minutes === 0 && counter.seconds === 0) {
        clearInterval(interval);
      } else {
        setCounter((prevCounter) => {
          if (prevCounter.seconds === 0) {
            return { minutes: prevCounter.minutes - 1, seconds: 59 };
          } else {
            return { ...prevCounter, seconds: prevCounter.seconds - 1 };
          }
        });
      }
    }, 1000);

    return () => clearInterval(interval);
  }, [counter]);

  return (
    <>
      <div className="flex  w-full min-h-screen bg-white">
        <div className="flex flex-col w-full">
          <Header />
          <div className="w-full h-full flex flex-col justify-center items-center">
            <div className="w-full max-w-[25rem] flex flex-col lg:px-0 px-3">
              <span
                className={`heading_1 ${
                  subdomain === "ndovupay" || subdomain === "localhost"
                    ? "!text-ndovuRed"
                    : "text-inherit"
                }`}
              >
                Verify your email
              </span>
              <span className="paragraph_1 mt-[.5rem]">
                We have sent an OTP to your email
              </span>

              <Form
                layout="vertical"
                ref={formRef}
                name="control-ref"
                onFinish={onFinish}
                style={{
                  maxWidth: "100%",
                  marginTop: "2.06rem",
                  width: "100%",
                }}
                form={form}
              >
                <div className="grid grid-cols-1">
                  <Form.Item
                    name="usrSecret"
                    label={
                      <span>
                        Enter OTP sent to{" "}
                        {forgotAcc?.usrEmail
                          ? obfuscateEmail(forgotAcc?.usrEmail)
                          : ""}{" "}
                        <span className="text-[#FF0000]">*</span>
                      </span>
                    }
                    rules={[
                      {
                        required: true,
                        message: "Please enter OTP",
                      },
                    ]}
                  >
                    <Input onChange={handleInputChange} className="input" />
                  </Form.Item>
                </div>

                <div className="flex mt-[1.63rem]">
                  <button
                    className={`cstm-btn-2 !bg-[#000000] ${
                      isInputEmpty ? "!bg-[#D1D5DB]" : "inherit"
                    } ${isInputEmpty ? "cursor-not-allowed" : "inherit"}`}
                    disabled={isInputEmpty}
                    type="submit"
                    key="submit"
                  >
                    {saving ? <Spin /> : "Submit"}
                  </button>
                </div>

                <div className="mt-[2rem] flex items-center justify-center w-full font-lexendS ">
                  {counter.minutes === 0 && counter.seconds === 0 ? (
                    <button
                      onClick={resendOTPEmail}
                      disabled={counter.minutes > 0 && counter.seconds > 0}
                      className="text-[#000] font-[300] text-[14px]  cursor-pointer"
                      type="button"
                    >
                      Didn’t receive code?
                    </button>
                  ) : (
                    <span className="underline text-[#DB2A12] font-[500]">
                      Resend in {counter.minutes.toString().padStart(2, "0")}:
                      {counter.seconds.toString().padStart(2, "0")}
                    </span>
                  )}
                </div>
              </Form>
            </div>
          </div>
        </div>

        <RightSide />
      </div>
    </>
  );
}

export default VerifyEmail;
